import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';

import {FROM_ENTITY_NOTIFICATION, NOTIFICATION_MESSAGE, LINK_LABEL, LINK, FROM_ENGAGEMENT} from '../utils/constants';
import {labels} from '../../../../../../../util/utils';
import {rootLevelId} from '../../../../../../../util/uiconstants';

import selectIsGroupRiskAssessmentProject from '../../../../../../../reducers/Project/selectors/selectIsGroupRiskAssessmentProject';

import Input from '../../../../../../CoreWrappers/Input'; 
import SelectDropdown from '../../../../../../Common/SelectDropdown/SelectDropdown';
import getAvailableEntityList from '../utils/getAvailableEntityList';
import {getEngagementMetaData} from '../../../../../../../actions/Engagement/engagementactions';
import StyledSubGrid from '../StyledSubGrid';

const GenerateNotification = ({
	values,
	errors,
	handleChange,
	handleSubmit,
	handleReset,
	isFormValid,
	schema,
	isLoading
}) => {
	const dashboardOrgChart = useSelector((store) => store.dashboardContext?.orgChart);
	const orgChart = useSelector((store) => store.orgChart);
	const engagementList = useSelector((store) => store.engagementMetaData);
	const projectId = useSelector((store) => store.project?.projectId);
	const userPreferences = useSelector(({userPreferences}) => userPreferences);
	const isGroupRiskAssessmentProject = selectIsGroupRiskAssessmentProject();
	const dispatch = useDispatch();

	useEffect(() => {
		if (!engagementList) {
			dispatch(getEngagementMetaData(projectId, userPreferences?.userType));
		}
	}, []);

	const renderFromEntity = () => {
		const id = FROM_ENTITY_NOTIFICATION;

		const props = {
			id,
			name: id,
			formLabel: labels[id],
			value: values[id] ? [values[id]] : null,
			options: isGroupRiskAssessmentProject ? getAvailableEntityList(dashboardOrgChart).filter(e => e.entityLevel > rootLevelId) : getAvailableEntityList(dashboardOrgChart),
			onChange: (value) => handleChange(id, value, {[FROM_ENGAGEMENT]: null}),
			isDisabled: isLoading,
			maxOptionsBeforeScroll: 5,
			menuPlacement: 'bottom',
			className: 'half-row'
		};

		if(values[id] !== null) props.defaultValue = [values[id]];

		if (errors[id]) {
			props.showErrorMessage = !!errors[id]?.error;
			props.errorMessage = errors[id]?.message || '';
		}

		return (
				<SelectDropdown {...props} />
		);
	};

	const renderFromEngagement = () => {
		const id = FROM_ENGAGEMENT;

		let filteredEngagements = [];

		if (values[FROM_ENTITY_NOTIFICATION]) {
			const engagementFilter = orgChart.filter((x) => x.entityId === values[FROM_ENTITY_NOTIFICATION].id)[0]?.engagements;
			filteredEngagements = engagementList?.filter((x) => engagementFilter?.includes(x.id));
		}

		const props = {
			id,
			name: id,
			formLabel: labels[id],
			value: values[id] ? [values[id]] : null,
			options: filteredEngagements,
			onChange: (value) => handleChange(id, value),
			isDisabled: isLoading || values[FROM_ENTITY_NOTIFICATION] === null,
			maxOptionsBeforeScroll: 5,
			menuPlacement: 'bottom',
			className : 'half-row'
		};

		if (values[id] !== null) props.defaultValue = [values[id]];

		if (errors[id]) {
			props.showErrorMessage = !!errors[id]?.error;
			props.errorMessage = errors[id]?.message || '';
		}

		return (
				<SelectDropdown {...props} />
		);
	};

	const renderNotificationMessage = () => {
		const id = NOTIFICATION_MESSAGE;

		const props = {
			id,
			disabled: isLoading,
			label: labels[id],
			maxLength: schema[id].maxLength,
			required: true,
			onChange: (e) => handleChange(id, e.target.value),
			onBlur: () => handleChange(id, values[id].trim()),
			value: values[id],
			className : 'full-row'
		};

		if (errors[id]) {
			props.errorMessage = !!errors[id]?.error? errors[id]?.message?? '' : null;
		}

		return  (<Input {...props} />);
	};

	const renderLinkLabel = () => {
		const id = LINK_LABEL;

		const props = {
			id,
			disabled: isLoading,
			label: labels[id],
			maxLength: schema[id].maxLength,
			onChange: (e) => handleChange(id, e.target.value),
			onBlur: () => handleChange(id, values[id].trim()),
			value: values[id],
			className : 'half-row'
		};

		if (errors[id]) {
			props.errorMessage = !!errors[id]?.error? errors[id]?.message?? '' : null;
		}

		return (<Input {...props} />);
	};

	const renderLink = () => {
		const id = LINK;

		const props = {
			id,
			disabled: isLoading,
			label: labels[id],
			maxLength: schema[id].maxLength,
			onChange: (e) => handleChange(id, e.target.value),
			onBlur: () => handleChange(id, values[id].trim()),
			value: values[id],
			className: 'half-row'
		};

		if (errors[id]) {
			props.showinputerror = !!errors[id]?.error;
			props.errormessage = errors[id]?.message || '';
		}

		return (<Input {...props} />);
	};

	return (
		<StyledSubGrid>
			{renderFromEntity()}
			{renderFromEngagement()}
			{renderNotificationMessage()}
			{renderLinkLabel()}
			{renderLink()}
		</StyledSubGrid>
	);
};

export default GenerateNotification;
